import { useSelector } from 'react-redux';
import { RootState } from '../redux/reducers';
import { Mobile } from '../models/mobile';

export const useSelectedMobile = (): Mobile | undefined => {
    const { tags, selectedTagId } = useSelector((state: RootState) => state.tag);
    const selectedTag = tags.find((t) => t._id === selectedTagId);
    const { mobiles } = useSelector((state: RootState) => state.mobile);
    return mobiles.find((m) => m._id === selectedTag?.mobile);
};